import { initializeApp } from "firebase/app";
import { getAuth, signOut, getIdToken } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase, ref, set, get } from "firebase/database";
import { getStorage } from "firebase/storage";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  doc,
  query,
  where,
  addDoc,
} from "firebase/firestore";

// Firebase Config (Replace with your actual Firebase config)
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize Firebase Authentication
const database = getDatabase(app);
const functions = getFunctions(app, "asia-east2");
const db = getFirestore(app);
const storage = getStorage(app);

export {
  auth,
  app,
  database,
  functions,
  httpsCallable,
  ref,
  set,
  get,
  signOut,
  getIdToken,
  getAuth,
  collection,
  getDocs,
  getDoc,
  setDoc,
  db,
  doc,
  query,
  where,
  addDoc,
  storage,
};
